import { render, staticRenderFns } from "./PointItem.vue?vue&type=template&id=60dfef63&scoped=true&"
import script from "./PointItem.vue?vue&type=script&lang=js&"
export * from "./PointItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfef63",
  null
  
)

export default component.exports